import { Component } from '@angular/core';
import { IWidgetSettings } from '@cloud-twin-v2/cloud-twin-shared/filtrable-items/widget-settings';
import { IntegrableFormParams } from '@common-modules/shared/forms/integrable-form';
import { BaseDashboardSettingsComponent } from '../core/base-dashboard-settings.component';

@Component({
  selector: 'ct-dashboard-category-chart-settings',
  templateUrl: './dashboard-category-chart-settings.component.html',
  styleUrl: './dashboard-category-chart-settings.component.scss',
  standalone: false,
})
export class DashboardCategoryChartSettingsComponent extends BaseDashboardSettingsComponent {
  getWidgetSettings(): IWidgetSettings {
    throw new Error('Method not implemented.');
  }
  setParams(params: IntegrableFormParams): void {
    throw new Error('Method not implemented.');
  }
  getModel() {
    throw new Error('Method not implemented.');
  }
  setInitialModel(model: any): void {
    throw new Error('Method not implemented.');
  }
}
